import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

export type UtmQueryRedux = {
    utmId:string | null
}

const initialState:UtmQueryRedux = {
    utmId:null
}

const utmCampaignSlice = createSlice({
    name:'utm_campaign',
    initialState,
    reducers:{
        
         setUtmId: (state, action: PayloadAction<string | null>) => {
            state.utmId = action.payload

        }
    }
})

export const selectUtmCampaign = (rootState:RootState) => rootState.utm.utmId

export const {setUtmId} = utmCampaignSlice.actions;
export default utmCampaignSlice.reducer